import { testimonials } from "../../../mocks/trendData";

export default function Testimonials() {
  return (
    <section className="bg-background-100 py-10 md:py-14" aria-label="读者口碑">
      <div className="container-x">
        <div className="text-center">
          <span className="section-kicker">读者口碑</span>
          <h2 className="mt-3 font-heading text-xl font-black tracking-tight text-foreground-950 md:text-3xl">
            追热点，也可以不被带节奏
          </h2>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex gap-0.5 text-accent-500" aria-label="五星评价">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i className="ri-user-3-line" aria-hidden="true"></i>
                </span>
                <div className="text-sm">
                  <div className="font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}